export const Endpoints = {
  plans: "subscription-plans",
  subscriptions: "subscriptions",
  login: "login",
  cards: "credit-card",
  payment_methods: "payment-methods",
  send_recovery_email: "password/email",
  home_info: "home-info",
  user: "users",
  appointments: "appointments",
  stripe_connect_onboarding: "users/stripe-connect-onboarding",
  payouts: "payouts",
  chats: "appointment-chats",
  chat_messages: "appointment-chat-messages",
  update_stripe_pending: "users/stripe-connect",
  stripe_connect_reset: "users/stripe-connect-reset",
  bank_codes: "bank-codes",
  my_banks: "my-banks",
  plan_details: "plan-details",
  user_registered_email: "users/registeredEmail",
  languages: "languages",
  available_days: "find-psychologists/availableDays",
  available_times: "find-psychologists/availableTimes",
  specific_day_schedules: "specific-day-schedules",
  terms_of_use_psi: "terms-of-use-psi",
  terms_of_use: "terms-of-use",
  privacy_policy: "privacy-policy",
  app_crashes: "app-crashes",
  notifications: "notifications",
  patients: "patients",
  appointment_recurrencies: "appointment-recurrencies",
  reschedule_requests: "reschedule-requests",
  call_rating: "calls-rating",
  coupons: "coupons",
  check_coupon: "check-coupon",
  occupation_areas: "occupation-area",
  approaches: "approaches",
  call_events: "call-event",
  partnership: "partner-patients",
  check_partnership: "check-partnership-limit",
  users_slug: "users/slug",
  find_psychologists: "find-psychologists",
  psy_signup_active: "psy-signup-active",
  shared_appointment_slots: "shared-appointment-slots",
  blog_posts: "blog/posts",
  pamia_webview_url: "ai-chats/webview-url",
};
